import { useProductLoaders } from "../loaders/productLoaders"
import { SettingsModule, useSettingsLoaders } from "../../administration"
import { useFiltersHooks } from "../../../features/ui"
import { Category } from "../state/types"
import { DataType } from "../../../tables"
import { normalize } from "../../../utils/typeUtils"

export const useCategoryHooks = () => {
    const { search2 } = useFiltersHooks()

    const productLoaders = useProductLoaders()
    const settingsLoaders = useSettingsLoaders()

    const canRemoveCategory = async (categoryId: string) => {
        const { countProducts } = productLoaders()
        const productsCount = await countProducts('categoryId', categoryId)

        const { loadModuleSettings } = settingsLoaders()
        const purchaseSettings = await loadModuleSettings(SettingsModule.PURCHASES)
        const inSettings = Object.values(purchaseSettings.categorySaleYields || []).some(data => data.categoryId === categoryId)

        return productsCount === 0 && !inSettings
    }


    const searchCategories = (
        categories: Category[],
        searchText = ''
    ): Promise<Category[]> => {
        const valuesFn = async (categoryDT: DataType) => {
            const { name } = categoryDT as Category
            return [
                normalize(name)
            ]
        }

        const sortFn = (catA: DataType, catB: DataType) => 
            (catA as Category).name.localeCompare((catB as Category).name)

        return search2(categories, searchText, valuesFn, undefined, sortFn) as Promise<Category[]>
    }

    return {
        canRemoveCategory,
        searchCategories
    }
}
